"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gtmMetricsSubscriber;
var _environment = require("@sm/utils/dist/environment");
var _helpers = require("../helpers");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // fix for downstream tree-shaking
function gtmMetricsSubscriber(digitalDataEvent) {
  var data = digitalDataEvent.data,
    name = digitalDataEvent.name;
  var actionType = data.actionType,
    actionFlow = data.actionFlow;
  if (!actionType || !actionFlow) {
    return;
  }

  // flatten the data object
  var gtmDataLayer = _objectSpread(_objectSpread({}, data), data.data);
  delete gtmDataLayer.data;
  var envDetails = (0, _environment.getClientEnvironmentDetails)();
  if (envDetails.isBrowser) {
    var pagePath = window.location.pathname;
    window.dataLayer = window.dataLayer || [];
    var eventObj = function eventObj(_ref) {
      var hasGDPRConsent = _ref.hasGDPRConsent,
        userId = _ref.userId,
        packageId = _ref.packageId,
        email = _ref.email,
        countryCode = _ref.countryCode;
      return {
        PAGE_VIEW: {
          event: 'pageView',
          loadMarketingContainer: hasGDPRConsent,
          user_id: userId,
          package_id: packageId,
          email: (0, _helpers.maskEmail)(email),
          country_code: countryCode
        },
        VIRTUAL_PAGE_VIEW: {
          event: 'virtualPageView',
          virtualPageUrl: pagePath,
          virtualPageTitle: actionFlow
        },
        GDPR_ACTION: {
          event: actionFlow,
          loadMarketingContainer: actionFlow !== 'denyConsent'
        }
      };
    };
    var gtm = eventObj(gtmDataLayer)[actionType] || _objectSpread({
      event: name
    }, gtmDataLayer);
    if (Object.keys(gtm).length) {
      window.dataLayer.push(gtm);
    }
  }
}
module.exports = exports.default;
//# sourceMappingURL=GTMMeticsSubscriber.js.map